// SP は上に僅かな隙間だけ残してモーダルと分かるようにし、md+ は global-header
// (tailwind.config.ts の global-header-md = 80px) ぶんロゴを覗かせる。
const DETAIL_DRAWER_HEIGHT_VAR_CLASS =
  "[--detail-drawer-height:98dvh] md:[--detail-drawer-height:calc(100dvh-80px)]";

export const DETAIL_DRAWER_POPUP_HEIGHT_CLASS = `${DETAIL_DRAWER_HEIGHT_VAR_CLASS} max-h-[var(--detail-drawer-height)]`;

// 本体スクロール領域の見える高さ (Popup − grip bar 24px − safe-area)。
// Drawer 外 (Storybook 等) でも解決できるよう変数定義ごと持たせる。
export const DETAIL_DRAWER_BODY_HEIGHT_CLASS = `${DETAIL_DRAWER_HEIGHT_VAR_CLASS} h-[calc(var(--detail-drawer-height)-24px-env(safe-area-inset-bottom,0px))]`;
